import React from 'react';
import ReactDOM from 'react-dom';
import './theme/index.css';
import App from './components/App';
import datadogLogs from './utils/datadogLogs'
import { configureStore } from './redux/store/';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const store = configureStore()
datadogLogs()

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
